// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>16</span>&nbsp;&nbsp;Who will rise up for me against the wicked?&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;Who will take my part against the evildoers?<br> </p> </div></div>";
// Exports
module.exports = code;